import httpWrapper from '../HttpWrapper'
import {
    GetHelixSearchStatusReq,
    GetHelixSearchStatusRes,
    StartHelixSearchV2Req,
    StartHelixSearchV2Res,
} from './models/StartHelixSearchV2'
import {
    GetHelixSearchResultsCountV2Req,
    GetHelixSearchResultsCountV2Res,
    GetHelixSearchResultsV2Req,
    GetHelixSearchResultsV2Res,
} from './models/HelixSearchV2Results'
import {
    GetHelixSearchQueueReq,
    GetHelixSearchQueueRes,
    ManualFailHelixSearchLogReq,
    ManualFailHelixSearchLogRes,
    PurgeHelixSearchQueueReq,
    PurgeHelixSearchQueueRes,
} from './models/HelixSearchQueue'
import {
    GetHelixSearchSessionsForRoleReq,
    GetHelixSearchSessionsForRoleRes,
} from './models/HelixSearchSessions'
import {
    AutoPopulateFiltersReq,
    AutoPopulateFiltersRes,
} from './models/AutoPopulateFilters'

class HelixSearchV2Api {
    public async startNewHelixSearch(
        req: StartHelixSearchV2Req,
    ): Promise<StartHelixSearchV2Res> {
        return await httpWrapper.post('/helix-v2-search/start-new', req)
    }

    public async autoPopulateFilters(
        req: AutoPopulateFiltersReq,
    ): Promise<AutoPopulateFiltersRes> {
        return await httpWrapper.post(
            '/helix-v2-search/filters/auto-populate',
            req,
        )
    }

    public async persistFilters(req: StartHelixSearchV2Req): Promise<void> {
        await httpWrapper.post('/helix-v2-search/filters/save', req)
    }

    public async getSearchStatus(
        req: GetHelixSearchStatusReq,
    ): Promise<GetHelixSearchStatusRes> {
        const queryParams = new URLSearchParams({
            sst: req.sst,
        })
        return await httpWrapper.get('/helix-v2-search/status', queryParams)
    }

    public async getResults(
        req: GetHelixSearchResultsV2Req,
    ): Promise<GetHelixSearchResultsV2Res> {
        return await httpWrapper.post('/helix-v2-search/results', req)
    }

    public async getResultsCount(
        req: GetHelixSearchResultsCountV2Req,
    ): Promise<GetHelixSearchResultsCountV2Res> {
        return await httpWrapper.post('/helix-v2-search/results/count', req)
    }

    public async getQueue(
        params: GetHelixSearchQueueReq = {},
    ): Promise<GetHelixSearchQueueRes> {
        const queryParams = new URLSearchParams()

        if (params.pageNumber !== undefined) {
            queryParams.set('pageNumber', String(params.pageNumber))
        }

        if (params.perPage !== undefined) {
            queryParams.set('perPage', String(params.perPage))
        }

        if (params.statuses?.length) {
            params.statuses.forEach((status) =>
                queryParams.append('statuses', status),
            )
        }

        return await httpWrapper.get<GetHelixSearchQueueRes>(
            '/helix-v2-search/queue',
            queryParams,
        )
    }

    public async manualFailLog(
        req: ManualFailHelixSearchLogReq,
    ): Promise<ManualFailHelixSearchLogRes> {
        return await httpWrapper.post<
            ManualFailHelixSearchLogReq,
            ManualFailHelixSearchLogRes
        >('/helix-v2-search/queue/manual-fail', req)
    }

    public async purgeQueue(
        req: PurgeHelixSearchQueueReq,
    ): Promise<PurgeHelixSearchQueueRes> {
        return await httpWrapper.post<
            PurgeHelixSearchQueueReq,
            PurgeHelixSearchQueueRes
        >('/helix-v2-search/queue/purge', req)
    }

    public async getSessionsForRole(
        req: GetHelixSearchSessionsForRoleReq,
    ): Promise<GetHelixSearchSessionsForRoleRes> {
        return await httpWrapper.post<
            GetHelixSearchSessionsForRoleReq,
            GetHelixSearchSessionsForRoleRes
        >('/helix-v2-search/sessions/by-role', req)
    }
}

const helixSearchV2Api = new HelixSearchV2Api()
export default helixSearchV2Api
